<template>
    <div class="presentation-header">
        <h3
            class="title"
            :class="inlineEditInProgress && 'editing'">
            <span class="presentation-title">
                {{ presentationIn.name }}

                <b-button
                    class="btn-edit btn-presentation-title-inline-edit-toggle"
                    variant="primary-icon-only"
                    @click="inlineEditInProgress = true">
                </b-button>
            </span>

            <div
                class="presentation-title-inline-edit"
                v-if="inlineEditInProgress">
                <b-form-input v-model="name"></b-form-input>
                <b-button
                    class="btn-checked btn-update"
                    variant="success-icon-only"
                    @click="updateTitle">
                </b-button>
                <b-button
                    class="btn-times btn-cancel"
                    variant="primary-icon-only"
                    @click="cancelUpdateTitle">
                </b-button>
            </div>
        </h3>

        <div class="title-buttons">
            <b-button
                class="btn-chalkboard-teacher"
                variant="primary"
                @click="showLesson">
                {{ $t('presentation.start_presentation') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-presentation-title-component',
    props: {
        presentationIn: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            inlineEditInProgress: false,
            name: this.presentationIn.name,
        };
    },
    methods: {
        updateTitle() {
            let data = {
                name: this.name,
            };
            this.axios.post(this.routes.presentationEdit(this.presentationIn.id), data).then(
                (response) => {
                    this.inlineEditInProgress = false;
                    this.$emit('presentation-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        cancelUpdateTitle() {
            this.inlineEditInProgress = false;
            this.name = this.presentationIn.name;
        },
        showLesson() {
            window.location.href = this.routes.presentationShow(this.presentationIn.id);
        },
    },
};
</script>

<style scoped lang="scss">
.presentation-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    gap: map-get($grid-gutter-spacing, 'fifteen') $grid-gutter-width;

    .title {
        flex: 1 0;

        &.editing {
            .presentation-title {
                display: none;
                opacity: 0;
                width: 0;
                height: 0;
                left: -100%;
            }

            .presentation-title-inline-edit {
                opacity: 1;
            }
        }
    }

    .presentation-title,
    .presentation-title-inline-edit {
        display: flex;
        align-items: center;
        transition: all 0.8s ease;
    }

    .presentation-title {
        position: relative;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');
        opacity: 1;
        width: auto;
        height: auto;

        .btn-update-title {
            &:before {
                margin: 0;
            }
        }
    }

    .presentation-title-inline-edit {
        column-gap: map-get($grid-gutter-spacing, 'eight');
        opacity: 0;
        width: 100%;

        input {
            margin: 0;
            border: 1px solid $primary;
            padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
        }

        .btn {
            font-size: 1.125rem;

            &:before {
                margin: 0;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .presentation-header {
        .presentation-title-inline-edit {
            width: 100%;
        }
    }
}
</style>
